<!-- Main container -->
<div>
  <!-- BANNER WITH SUPPORTING ICON Section: Start -->
  <dls-page-section-container headline="Banner with supporting icon">
    <dls-page-section>
      <section>
        <dls-example-viewer title="Banner with supporting icon">
          <div HTML>
            <pre 
              class="language-html">
              <dls-code-block language="html" [codeSnippet]="bannerWithSupportingIconExample['HTML']"></dls-code-block></pre>
          </div>
          <div TS>
            <pre
              class="language-typescript"><dls-code-block language="typescript" [codeSnippet]="bannerWithSupportingIconExample['TS']"></dls-code-block></pre>
          </div>
          <div SCSS>
            <pre class="language-scss"><dls-code-block language="scss" [codeSnippet]="bannerWithSupportingIconExample['SCSS']"></dls-code-block></pre>
          </div>
          <div HTML>
            <pre 
              class="language-html">
              <dls-code-block language="html" [codeSnippet]="bannerWithSupportingIconExample['DEMOHTML']"></dls-code-block></pre>
          </div>
          <div TS>
            <pre
              class="language-typescript"><dls-code-block language="typescript" [codeSnippet]="bannerWithSupportingIconExample['DEMOTS']"></dls-code-block></pre>
          </div>
          <div example>
            <button atlas-outlined-button
              class="me-3"
              color="accent"
              (click)="openTemplate1()">
              Banner Template 1
            </button>
          </div>
        </dls-example-viewer>
      </section>
    </dls-page-section>
  </dls-page-section-container>
  <!-- BANNER WITH SUPPORTING ICON : End -->

  <!-- BANNER WITHOUT SUPPORTING ICON Section: Start -->
  <dls-page-section-container headline="Banner without supporting icon">
    <dls-page-section>
      <section>
        <dls-example-viewer title="Banner without supporting icon">
          <div HTML>
            <pre 
              class="language-html">
              <dls-code-block language="html" [codeSnippet]="bannerWithoutSupportingIconExample['HTML']"></dls-code-block></pre>
          </div>
          <div TS>
            <pre
              class="language-typescript"><dls-code-block language="typescript" [codeSnippet]="bannerWithoutSupportingIconExample['TS']"></dls-code-block></pre>
          </div>
          <div SCSS>
            <pre class="language-scss"><dls-code-block language="scss" [codeSnippet]="bannerWithoutSupportingIconExample['SCSS']"></dls-code-block></pre>
          </div>
          <div HTML>
            <pre 
              class="language-html">
              <dls-code-block language="html" [codeSnippet]="bannerWithoutSupportingIconExample['DEMOHTML']"></dls-code-block></pre>
          </div>
          <div TS>
            <pre
              class="language-typescript"><dls-code-block language="typescript" [codeSnippet]="bannerWithoutSupportingIconExample['DEMOTS']"></dls-code-block></pre>
          </div>
          <div example>
            <button atlas-outlined-button
              class="me-3"
              color="accent"
              (click)="openTemplate2()">
              Banner Template 2
            </button>
          </div>
        </dls-example-viewer>
      </section>
    </dls-page-section>
  </dls-page-section-container>
  <!-- BANNER WITHOUT SUPPORTING ICON : End -->

  <!-- BANNER DYNAMIC DATA Section: Start -->
  <dls-page-section-container headline="Dynamic Data">
    <dls-page-section>
      <section>
        <dls-example-viewer title="Banner with Dynamic Data">
          <div HTML>
            <pre 
              class="language-html">
              <dls-code-block language="html" [codeSnippet]="bannerDynamicDataExample['HTML']"></dls-code-block></pre>
          </div>
          <div TS>
            <pre
              class="language-typescript"><dls-code-block language="typescript" [codeSnippet]="bannerDynamicDataExample['TS']"></dls-code-block></pre>
          </div>
          <div SCSS>
            <pre class="language-scss"><dls-code-block language="scss" [codeSnippet]="bannerDynamicDataExample['SCSS']"></dls-code-block></pre>
          </div>
          <div HTML>
            <pre 
              class="language-html">
              <dls-code-block language="html" [codeSnippet]="bannerDynamicDataExample['DEMOHTML']"></dls-code-block></pre>
          </div>
          <div TS>
            <pre
              class="language-typescript"><dls-code-block language="typescript" [codeSnippet]="bannerDynamicDataExample['DEMOTS']"></dls-code-block></pre>
          </div>
          <div example>
            <div class="row mb-4">
              <div class="col-12 col-md-6">
                <h3 class="mat-headline">Passing Dynamic Data</h3>
                <form
                  [formGroup]="bannerForm"
                  (ngSubmit)="openTemplate3()">
                  <atlas-input 
                    formControlName="content"
                    type="text"
                    required>
                    <span label>
                      Content
                    </span>
                  </atlas-input>
                  <atlas-input 
                    formControlName="imageURL"
                    type="text"
                    required>
                    <span label>
                      Image URL
                    </span>
                  </atlas-input>
                  <atlas-input
                    formControlName="secondaryAction"
                    type="text"
                    required>
                    <span label>
                      Secondary Action
                    </span>
                  </atlas-input>
                  <atlas-input
                    formControlName="primaryAction"
                    type="text"
                    required>
                    <span label>
                      Primary Action
                    </span>
                  </atlas-input>
                  <button atlas-contained-button
                    color="accent"
                    class="text-uppercase w-100 mt-3"
                    [disabled]="bannerForm.invalid">
                    Add Dynamic Data
                  </button>
                </form>
              </div>
            </div>
          </div>
        </dls-example-viewer>
      </section>
    </dls-page-section>
  </dls-page-section-container>
  <!-- BANNER DYNAMIC DATA : End -->

  <!-- BANNER SHOW AND CLOSE PROGRAMMATICALLY Section: Start -->
  <dls-page-section-container headline="Show and close Programmatically">
    <dls-page-section>
      <section>
        <dls-example-viewer title="Banner with show and close programmatically">
          <div HTML>
            <pre 
              class="language-html">
              <dls-code-block language="html" [codeSnippet]="bannerShowCloseExample['HTML']"></dls-code-block></pre>
          </div>
          <div TS>
            <pre
              class="language-typescript"><dls-code-block language="typescript" [codeSnippet]="bannerShowCloseExample['TS']"></dls-code-block></pre>
          </div>
          <div SCSS>
            <pre class="language-scss"><dls-code-block language="scss" [codeSnippet]="bannerShowCloseExample['SCSS']"></dls-code-block></pre>
          </div>
          <div HTML>
            <pre 
              class="language-html">
              <dls-code-block language="html" [codeSnippet]="bannerShowCloseExample['DEMOHTML']"></dls-code-block></pre>
          </div>
          <div TS>
            <pre
              class="language-typescript"><dls-code-block language="typescript" [codeSnippet]="bannerShowCloseExample['DEMOTS']"></dls-code-block></pre>
          </div>
          <div example>
            <button atlas-outlined-button
              class="me-3"
              color="accent"
              (click)="openTemplate4()">
              Show Banner
            </button>
            <button atlas-outlined-button
              color="accent"
              (click)="onBannerClose()">
              Close Banner
            </button>
          </div>
        </dls-example-viewer>
      </section>
    </dls-page-section>
  </dls-page-section-container>
  <!-- BANNER SHOW AND CLOSE PROGRAMMATICALLY : End -->
</div>